module.exports = __webpack_public_path__ + "prod/1.42.2/img/wudian-bg.e96ec2ff.png";